/* eslint-disable react/prop-types */
import { Center, Loader, Text } from "@mantine/core";

/**
 * Loading vs empty vs rows. `items` is null/undefined until the fetch returns.
 * Pass a function child so the table is not built against a missing array.
 */
export default function ListPending({ items, emptyText, children }) {
  if (!Array.isArray(items)) {
    return (
      <Center py="xl">
        <Loader />
      </Center>
    );
  }
  if (items.length === 0) {
    return (
      <Text c="dimmed" ta="center" py="lg">
        {emptyText}
      </Text>
    );
  }
  return children(items);
}
